import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));



  // ✅ Identifier l'onglet courant de façon unique
const tabId = `${Date.now()}-${Math.random()}`;
sessionStorage.setItem('tabId', tabId);

// ✅ Créer le canal de communication entre onglets
const channel = new BroadcastChannel('tab-control');

channel.onmessage = (event) => {
  const currentTabId = sessionStorage.getItem('tabId');
  const targetTabId = event.data?.activeTabId;

  console.log("✅ currentTabId:", currentTabId);
  console.log("✅ targetTabId :", targetTabId);

  // ❌ Si ce n’est pas l’onglet principal
  if (targetTabId && currentTabId !== targetTabId) {
    console.warn("⛔ Cet onglet est désactivé");

    // 🔄 Essayer de fermer l'onglet automatiquement
    window.close();

    // 🕐 Si ça ne marche pas (onglet ouvert manuellement), bloquer l'écran
    setTimeout(() => {
      if (!window.closed) {
        document.body.innerHTML = `
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
            font-size: 18px;
            background-color: #fff;
            color: #333;
            text-align: center;
            padding: 20px;
            gap: 30px;
          ">
            <div>
              <p style="margin: 0; font-weight: bold;">❌ You have switched hotels in another tab.</p>
              <p>Please <strong>close this tab or refresh the page</strong>.</p>
            </div>
    
            <div>
              <p style="margin: 0; font-weight: bold;">❌ Vous avez changé d'hôtel depuis un autre onglet.</p>
              <p>Merci de <strong>fermer cette page ou actualiser la page</strong>.</p>
            </div>
          </div>
        `;
        document.title = "Tab deactivated";
    
        (window as any).tryClose = () => {
          window.close();
        };
      }
    }, 100);
    
    
    
    
  }
};






  


  